export function formatDate(date: Date) {
	const formatted = new Date(date).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
	});

	return formatted;
}

export function getOfficialDrawDateWithSuffix(date: Date): string {
	const nextDay = new Date(date);
	nextDay.setDate(nextDay.getDate() + 1);

	const day = nextDay.getDate();
	const month = nextDay.toLocaleString("en-US", { month: "long" });

	const ordinalSuffix = (n: number) => {
		if (n >= 11 && n <= 13) return "th";
		switch (n % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	};

	const formattedDay = `${day}${ordinalSuffix(day)}`;

	return `${formattedDay} of ${month}`;
}

export function getOfficialDrawDate(date: Date): string {
	const nextDay = new Date(date);
	nextDay.setDate(nextDay.getDate() + 1);

	return nextDay.toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});
}
